import { n as v } from "../property-4FoNj0Pi.js";
import { r as q } from "../state-D4BCZ2JK.js";
import { c as Ee } from "../lit-element-8JrrHldg.js";
import { e as Fe, n as B } from "../ref-ArR26hg7.js";
import { I as Ie } from "../IdController-Cpj_A6H5.js";
import "./pwc-label.js";
import "./pwc-input-surface.js";
import "./pwc-input-message.js";
import "./pwc-icon.js";
import { o as h } from "../if-defined-Cd-e8xtV.js";
import { s as Oe, u as S } from "../static-CPcCYSrK.js";
import { c as E } from "../clsx-DB4S2d7J.js";
import { P as Pe } from "../pwc-interactive-element-B6286Ky3.js";
import { a as I, _ as m, p as Ae } from "../pwcProperty-CTLG9yrF.js";
import "../cross-De9fASU6.js";
const Me = Array.isArray || function(t) {
  return t != null && t.length >= 0 && Object.prototype.toString.call(t) === "[object Array]";
};
function xe(e) {
  return e != null && typeof e["@@transducer/step"] == "function";
}
function He(e, t, r) {
  return function() {
    if (arguments.length === 0)
      return r();
    var n = arguments[arguments.length - 1];
    if (!Me(n)) {
      for (var i = 0; i < e.length; ) {
        if (typeof n[e[i]] == "function")
          return n[e[i]].apply(n, Array.prototype.slice.call(arguments, 0, -1));
        i += 1;
      }
      if (xe(n)) {
        var s = t.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return s(n);
      }
    }
    return r.apply(this, arguments);
  };
}
const T = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(e) {
    return this.xf["@@transducer/result"](e);
  }
};
function V(e) {
  for (var t = [], r; !(r = e.next()).done; )
    t.push(r.value);
  return t;
}
function Z(e, t, r) {
  for (var n = 0, i = r.length; n < i; ) {
    if (e(t, r[n]))
      return !0;
    n += 1;
  }
  return !1;
}
function Le(e) {
  var t = String(e).match(/^function (\w*)/);
  return t == null ? "" : t[1];
}
function $(e, t) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function be(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
const F = typeof Object.is == "function" ? Object.is : be;
var D = Object.prototype.toString, ze = /* @__PURE__ */ function() {
  return D.call(arguments) === "[object Arguments]" ? function(t) {
    return D.call(t) === "[object Arguments]";
  } : function(t) {
    return $("callee", t);
  };
}(), qe = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), W = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], j = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), ke = function(t, r) {
  for (var n = 0; n < t.length; ) {
    if (t[n] === r)
      return !0;
    n += 1;
  }
  return !1;
}, U = typeof Object.keys == "function" && !j ? /* @__PURE__ */ I(function(t) {
  return Object(t) !== t ? [] : Object.keys(t);
}) : /* @__PURE__ */ I(function(t) {
  if (Object(t) !== t)
    return [];
  var r, n, i = [], s = j && ze(t);
  for (r in t)
    $(r, t) && (!s || r !== "length") && (i[i.length] = r);
  if (qe)
    for (n = W.length - 1; n >= 0; )
      r = W[n], $(r, t) && !ke(i, r) && (i[i.length] = r), n -= 1;
  return i;
}), G = /* @__PURE__ */ I(function(t) {
  return t === null ? "Null" : t === void 0 ? "Undefined" : Object.prototype.toString.call(t).slice(8, -1);
});
function R(e, t, r, n) {
  var i = V(e), s = V(t);
  function a(l, f) {
    return k(l, f, r.slice(), n.slice());
  }
  return !Z(function(l, f) {
    return !Z(a, f, l);
  }, s, i);
}
function k(e, t, r, n) {
  if (F(e, t))
    return !0;
  var i = G(e);
  if (i !== G(t))
    return !1;
  if (typeof e["fantasy-land/equals"] == "function" || typeof t["fantasy-land/equals"] == "function")
    return typeof e["fantasy-land/equals"] == "function" && e["fantasy-land/equals"](t) && typeof t["fantasy-land/equals"] == "function" && t["fantasy-land/equals"](e);
  if (typeof e.equals == "function" || typeof t.equals == "function")
    return typeof e.equals == "function" && e.equals(t) && typeof t.equals == "function" && t.equals(e);
  switch (i) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof e.constructor == "function" && Le(e.constructor) === "Promise")
        return e === t;
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof e == typeof t && F(e.valueOf(), t.valueOf())))
        return !1;
      break;
    case "Date":
      if (!F(e.valueOf(), t.valueOf()))
        return !1;
      break;
    case "Error":
      return e.name === t.name && e.message === t.message;
    case "RegExp":
      if (!(e.source === t.source && e.global === t.global && e.ignoreCase === t.ignoreCase && e.multiline === t.multiline && e.sticky === t.sticky && e.unicode === t.unicode))
        return !1;
      break;
  }
  for (var s = r.length - 1; s >= 0; ) {
    if (r[s] === e)
      return n[s] === t;
    s -= 1;
  }
  switch (i) {
    case "Map":
      return e.size !== t.size ? !1 : R(e.entries(), t.entries(), r.concat([e]), n.concat([t]));
    case "Set":
      return e.size !== t.size ? !1 : R(e.values(), t.values(), r.concat([e]), n.concat([t]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return !1;
  }
  var a = U(e);
  if (a.length !== U(t).length)
    return !1;
  var l = r.concat([e]), f = n.concat([t]);
  for (s = a.length - 1; s >= 0; ) {
    var g = a[s];
    if (!($(g, t) && k(t[g], e[g], l, f)))
      return !1;
    s -= 1;
  }
  return !0;
}
var Ce = /* @__PURE__ */ m(function(t, r) {
  return k(t, r, [], []);
});
function Be(e, t, r) {
  var n, i;
  if (typeof e.indexOf == "function")
    switch (typeof t) {
      case "number":
        if (t === 0) {
          for (n = 1 / t; r < e.length; ) {
            if (i = e[r], i === 0 && 1 / i === n)
              return r;
            r += 1;
          }
          return -1;
        } else if (t !== t) {
          for (; r < e.length; ) {
            if (i = e[r], typeof i == "number" && i !== i)
              return r;
            r += 1;
          }
          return -1;
        }
        return e.indexOf(t, r);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return e.indexOf(t, r);
      case "object":
        if (t === null)
          return e.indexOf(t, r);
    }
  for (; r < e.length; ) {
    if (Ce(e[r], t))
      return r;
    r += 1;
  }
  return -1;
}
function N(e, t) {
  return Be(t, e, 0) >= 0;
}
const Te = Number.isInteger || function(t) {
  return t << 0 === t;
};
function Ve(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
var Ze = /* @__PURE__ */ m(function(t, r) {
  var n = t < 0 ? r.length + t : t;
  return Ve(r) ? r.charAt(n) : r[n];
}), re = /* @__PURE__ */ function() {
  function e() {
    this._nativeSet = typeof Set == "function" ? /* @__PURE__ */ new Set() : null, this._items = {};
  }
  return e.prototype.add = function(t) {
    return !X(t, !0, this);
  }, e.prototype.has = function(t) {
    return X(t, !1, this);
  }, e;
}();
function X(e, t, r) {
  var n = typeof e, i, s;
  switch (n) {
    case "string":
    case "number":
      return e === 0 && 1 / e === -1 / 0 ? r._items["-0"] ? !0 : (t && (r._items["-0"] = !0), !1) : r._nativeSet !== null ? t ? (i = r._nativeSet.size, r._nativeSet.add(e), s = r._nativeSet.size, s === i) : r._nativeSet.has(e) : n in r._items ? e in r._items[n] ? !0 : (t && (r._items[n][e] = !0), !1) : (t && (r._items[n] = {}, r._items[n][e] = !0), !1);
    case "boolean":
      if (n in r._items) {
        var a = e ? 1 : 0;
        return r._items[n][a] ? !0 : (t && (r._items[n][a] = !0), !1);
      } else
        return t && (r._items[n] = e ? [!1, !0] : [!0, !1]), !1;
    case "function":
      return r._nativeSet !== null ? t ? (i = r._nativeSet.size, r._nativeSet.add(e), s = r._nativeSet.size, s === i) : r._nativeSet.has(e) : n in r._items ? N(e, r._items[n]) ? !0 : (t && r._items[n].push(e), !1) : (t && (r._items[n] = [e]), !1);
    case "undefined":
      return r._items[n] ? !0 : (t && (r._items[n] = !0), !1);
    case "object":
      if (e === null)
        return r._items.null ? !0 : (t && (r._items.null = !0), !1);
    default:
      return n = Object.prototype.toString.call(e), n in r._items ? N(e, r._items[n]) ? !0 : (t && r._items[n].push(e), !1) : (t && (r._items[n] = [e]), !1);
  }
}
var De = /* @__PURE__ */ function() {
  function e(t, r) {
    this.xf = r, this.f = t, this.set = new re();
  }
  return e.prototype["@@transducer/init"] = T.init, e.prototype["@@transducer/result"] = T.result, e.prototype["@@transducer/step"] = function(t, r) {
    return this.set.add(this.f(r)) ? this.xf["@@transducer/step"](t, r) : t;
  }, e;
}();
function We(e) {
  return function(t) {
    return new De(e, t);
  };
}
var je = /* @__PURE__ */ m(
  /* @__PURE__ */ He([], We, function(e, t) {
    for (var r = new re(), n = [], i = 0, s, a; i < t.length; )
      a = t[i], s = e(a), r.add(s) && n.push(a), i += 1;
    return n;
  })
), Ue = /* @__PURE__ */ m(function(t, r) {
  return t.map(function(n) {
    for (var i = r, s = 0, a; s < n.length; ) {
      if (i == null)
        return;
      a = n[s], i = Te(a) ? Ze(a, i) : i[a], s += 1;
    }
    return i;
  });
}), Ge = /* @__PURE__ */ m(function(t, r) {
  return Ue([t], r)[0];
}), Re = /* @__PURE__ */ m(function(t, r) {
  return t.map(function(n) {
    return Ge([n], r);
  });
});
let Ne = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="m12.85 4.65-3.5-3.5A.454.454 0 0 0 9 1H4a1.003 1.003 0 0 0-1 1v12a1.003 1.003 0 0 0 1 1h8a1.003 1.003 0 0 0 1-1V5a.454.454 0 0 0-.15-.35ZM9 2.2 11.8 5H9V2.2ZM12 14H4V2h4v3a1.003 1.003 0 0 0 1 1h3v8Z"></path></svg>';
  }
};
const J = "pi-document-blank";
customElements.get(J) || customElements.define(J, Ne);
class Xe extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M15 9V8h-3v5h1v-2h1.5v-1H13V9h2Zm-5.5 4h-2V8h2A1.502 1.502 0 0 1 11 9.5v2A1.502 1.502 0 0 1 9.5 13Zm-1-1h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-1v3Zm-3-4H3v5h1v-1.5h1.5a1.001 1.001 0 0 0 1-1V9a1.001 1.001 0 0 0-1-1ZM4 10.5V9h1.5v1.5H4Z"></path><path d="M11 7V5a.454.454 0 0 0-.15-.35l-3.5-3.5A.454.454 0 0 0 7 1H2a1.003 1.003 0 0 0-1 1v12a1 1 0 0 0 1 1h8v-1H2V2h4v3a1.003 1.003 0 0 0 1 1h3v1h1ZM7 5V2.2L9.8 5H7Z"></path></svg>';
  }
}
const K = "pi-document-pdf";
customElements.get(K) || customElements.define(K, Xe);
let Je = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="m13.15 10-.455 4.306L12 10h-1l-.695 4.306L9.85 10H9l.68 5h1.14l.68-4.187.68 4.187h1.14l.68-5h-.85Z"></path><path d="m11.854 4.646-3.5-3.5A.5.5 0 0 0 8 1H3a1 1 0 0 0-1 1v12a1.001 1.001 0 0 0 1 1h4v-1H3V2h4v3a1 1 0 0 0 1 1h3v2h1V5a.5.5 0 0 0-.146-.354ZM8 2.207 10.793 5H8V2.207Z"></path></svg>';
  }
};
const Q = "pi-document-word-processor";
customElements.get(Q) || customElements.define(Q, Je);
class Ke extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M9.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0-2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"></path><path d="M13 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm0 11H3v-3l2.5-2.5 2.795 2.795a1 1 0 0 0 1.41 0L10.5 9.5 13 12v1Zm0-2.415L11.205 8.79a1 1 0 0 0-1.41 0L9 9.585 6.205 6.79a1 1 0 0 0-1.41 0L3 8.585V3h10v7.585Z"></path></svg>';
  }
}
const Y = "pi-image";
customElements.get(Y) || customElements.define(Y, Ke);
class Qe extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13 4V2H3v2H2V2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2h-1Zm0 5-.705.705L8.5 5.915V15h-1V5.915l-3.795 3.79L3 9l5-5 5 5Z"></path></svg>';
  }
}
const ee = "pi-upload";
customElements.get(ee) || customElements.define(ee, Qe);
var Ye = Object.defineProperty, et = Object.getOwnPropertyDescriptor, u = (e, t, r, n) => {
  for (var i = n > 1 ? void 0 : n ? et(t, r) : t, s = e.length - 1, a; s >= 0; s--)
    (a = e[s]) && (i = (n ? a(t, r, i) : a(i)) || i);
  return n && i && Ye(t, r, i), i;
}, ne = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, te = (e, t, r) => (ne(e, t, "read from private field"), r ? r.call(e) : t.get(e)), p = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, o = (e, t, r) => (ne(e, t, "access private method"), r), d, _, O, ie, w, P, A, se, M, ae, x, le, H, L, b, ce, z, oe;
const ue = "pwc-file-input", tt = [
  "drag",
  "dragstart",
  "dragend",
  "dragover",
  "dragenter",
  "dragleave",
  "drop"
], pe = (e, t, r) => t ? t.replaceAll(" ", "").split(",").some((i) => i.startsWith(".") ? r == null ? void 0 : r.toLowerCase().endsWith(i.toLowerCase()) : i.endsWith("/*") ? e.type.startsWith(i.slice(0, -1)) : e.type === i.toLowerCase()) : !0;
let c = class extends Pe {
  constructor() {
    super(...arguments), p(this, d), p(this, O), p(this, w), p(this, A), p(this, M), p(this, x), p(this, b), p(this, z), this.dropzone = Fe(), this._files = [], this.accepted = null, this.dragOverDepth = 0, this.idController = new Ie(this, {
      base: "PwcFileInput",
      children: ["label", "input"]
    }), this.slotControlled = ["label"], p(this, H, (e) => {
      e.preventDefault(), e.stopPropagation();
    }), p(this, L, () => {
      var e;
      (e = this.interactiveEl) == null || e.click();
    });
  }
  get files() {
    var e;
    return ((e = this.interactiveEl) == null ? void 0 : e.files) ?? null;
  }
  set files(e) {
    this.interactiveEl.files = e, o(this, w, P).call(this);
  }
  get value() {
    return this.interactiveEl.value;
  }
  set value(e) {
    if (e !== "")
      throw new DOMException(
        "This element accepts a filename, which may only be programmatically set to the empty string."
      );
    this.interactiveEl.value = "", this._files = [];
  }
  ctaContent() {
    const e = this.text || (this.multiple ? "{Browse files} or drop them here" : "{Browse files} or drop it here");
    return Oe(
      e.replace(
        /{(.*)}/,
        '<span class="PwcFileInput__cta__browse">$1</span>'
      )
    );
  }
  firstUpdated() {
    super.firstUpdated();
    const e = this.dropzone.value;
    tt.forEach((t) => {
      e.addEventListener(t, te(this, H));
    }), e.addEventListener("dragenter", (t) => {
      var r;
      if (!(this.disabled || !(((r = t.dataTransfer) == null ? void 0 : r.types) ?? []).includes("Files"))) {
        if (!this.dragOverDepth && t.dataTransfer) {
          const n = Array.from(t.dataTransfer.items), i = n.reduce((s, a) => {
            var l;
            return s + (pe(a, this.accept, (l = a.getAsFile()) == null ? void 0 : l.name) ? 1 : 0);
          }, 0);
          this.accepted = i === 0 ? "none" : i === n.length ? "all" : "partial";
        }
        this.dragOverDepth++;
      }
    }), e.addEventListener("dragleave", (t) => {
      var r;
      this.disabled || !(((r = t.dataTransfer) == null ? void 0 : r.types) ?? []).includes("Files") || (this.dragOverDepth--, this.dragOverDepth || (this.accepted = null));
    }), e.addEventListener("drop", (t) => {
      if (this.disabled)
        return;
      this.dragOverDepth = 0, this.accepted = null;
      const r = o(this, O, ie).call(this, t.dataTransfer);
      this.files = o(this, d, _).call(this, this.multiple ? [...r, ...this._files] : r.splice(0, 1)), this.emit("p-input", {}), this.dispatchEvent(new Event("input")), this.focus();
    });
  }
  clear() {
    this.interactiveEl.value = "", o(this, w, P).call(this), this.emit("p-input", { detail: "" }), this.focus();
  }
  get describedBy() {
    return this.description ? `${this.idController.child.label}__description` : void 0;
  }
  render() {
    const {
      name: e,
      accept: t,
      accepted: r,
      label: n,
      description: i,
      describedBy: s,
      focused: a,
      disabled: l,
      required: f,
      errorMessages: g,
      warningMessages: fe,
      successMessages: he,
      hintMessage: de,
      hideDetails: ve,
      status: me,
      title: ge,
      idController: {
        id: _e,
        child: { label: ye, input: C }
      },
      slotted: we,
      multiple: $e
    } = this;
    return S`
      <div
        id=${_e}
        class="PwcFileInput ${E({
      "PwcFileInput--disabled": l,
      "PwcFileInput--acceptsAll": r === "all",
      "PwcFileInput--acceptsNone": r === "none",
      "PwcFileInput--acceptsPartial": r === "partial"
    })}"
      >
        <pwc-label
          id=${ye}
          class="PwcFileInput__label"
          for=${C}
          description=${h(i)}
          ?disabled=${l}
          ?required=${f}
        >
          ${we.label ? "" : n}
          <p-slot .host=${this} name="label"></p-slot>
          <p-slot
            .host=${this}
            name="description"
            p-slot="description"
          ></p-slot>
        </pwc-label>

        <div class="PwcFileInput__inner">
          <p-slot .host=${this} name="prepend-outer"></p-slot>
          <pwc-input-surface
            class="PwcFileInput__inputSurface"
            style="position: relative"
            dropzone
            status=${h(me)}
            ?focused=${a}
            ?disabled=${l}
          >
            <p-slot .host=${this} name="prepend"></p-slot>
            <input
              ${B(this.interactiveElementRef)}
              class="PwcFileInput__input"
              id=${C}
              style="position: absolute; opacity: 0; z-index: -1"
              aria-describedby=${h(s)}
              name=${h(e)}
              accept="${h(t)}"
              type="file"
              title=${h(ge)}
              ?multiple=${$e}
              ?disabled=${l}
              ?required=${f}
              @input=${o(this, M, ae)}
              @change=${o(this, x, le)}
            />
            <div
              class=${E("PwcFileInput__dropzone", {
      "PwcFileInput__dropzone--dragOver": this.dragOverDepth
    })}
              ${B(this.dropzone)}
              @click=${te(this, L)}
            >
              <div class="PwcFileInput__cta">
                <pwc-icon
                  icon="upload"
                  class="PwcFileInput__cta__icon"
                ></pwc-icon>
                <div class="PwcFileInput__cta__content">
                  ${this.ctaContent()}
                </div>
              </div>
              <div
                class=${E("PwcFileInput__files", {
      "PwcFileInput__files--empty": !this._files.length
    })}
              >
                ${this._files.map(
      (y) => S`
                    <div class="PwcFileInput__file">
                      <pwc-icon
                        class="PwcFileInput__file__icon"
                        icon=${o(this, z, oe).call(this, y)}
                      ></pwc-icon>
                      <div class="PwcFileInput__file__name">${y.name}</div>
                      <div class="PwcFileInput__file__size">
                        ${o(this, b, ce).call(this, y)}
                      </div>
                      <button
                        class="PwcFileInput__file__remove"
                        @click=${(Se) => {
        Se.stopPropagation(), o(this, A, se).call(this, y);
      }}
                      >
                        <pwc-icon icon="cross"></pwc-icon>
                      </button>
                    </div>
                  `
    )}
              </div>
            </div>
            <p-slot .host=${this} name="append"></p-slot>
          </pwc-input-surface>
          <p-slot .host=${this} name="append-outer"></p-slot>
        </div>
        <div class="PwcFileInput__bottom">
          ${ve ? "" : S` <pwc-input-message
                .errorMessages=${g}
                .warningMessages=${fe}
                .successMessages=${he}
                .hintMessage=${a ? de : void 0}
              ></pwc-input-message>`}
        </div>
      </div>
    `;
  }
};
d = /* @__PURE__ */ new WeakSet();
_ = function(e) {
  const t = new DataTransfer(), r = Re(["name", "size"]);
  return je(r, e).forEach((n) => t.items.add(n)), t.files;
};
O = /* @__PURE__ */ new WeakSet();
ie = function(e) {
  return Array.from(e.items).map((t) => {
    var n, i;
    const r = ((n = t.webkitGetAsEntry) == null ? void 0 : n.call(t)) ?? ((i = t.getAsEntry) == null ? void 0 : i.call(t));
    return r != null && r.isFile ? t.getAsFile() : null;
  }).filter((t) => t && pe(t, this.accept, t.name));
};
w = /* @__PURE__ */ new WeakSet();
P = function() {
  this._files = Array.from(this.files ?? []);
};
A = /* @__PURE__ */ new WeakSet();
se = function(e) {
  this.files = o(this, d, _).call(this, this._files.filter((t) => t !== e)), this.emit("p-input", {});
};
M = /* @__PURE__ */ new WeakSet();
ae = function(e) {
  var r;
  if (!((r = this.files) != null && r.length)) {
    this.interactiveEl.files = o(this, d, _).call(this, this._files);
    return;
  }
  const t = [...Array.from(this.files), ...this._files];
  this.files = o(this, d, _).call(this, this.multiple ? t : t.splice(0, 1)), this.emit("p-input", { detail: e.target.value }), this.focus();
};
x = /* @__PURE__ */ new WeakSet();
le = function(e) {
  this.emit("p-change", { detail: e.target.value });
};
H = /* @__PURE__ */ new WeakMap();
L = /* @__PURE__ */ new WeakMap();
b = /* @__PURE__ */ new WeakSet();
ce = function(e) {
  return e.size > 2 ** 30 ? `${(e.size / 2 ** 30).toFixed(1)} GB` : e.size > 2 ** 20 ? `${(e.size / 2 ** 20).toFixed(1)} MB` : e.size > 2 ** 10 ? `${Math.round(e.size / 2 ** 10)} kB` : `${(e.size / 2 ** 10).toFixed(1)} kB`;
};
z = /* @__PURE__ */ new WeakSet();
oe = function(e) {
  return /^image/.test(e.type) ? "image" : /\.docx?$/.test(e.name) ? "document-word-processor" : /\.pdf$/.test(e.name) ? "document-pdf" : "document-blank";
};
c.tagName = ue;
u([
  v({ type: String })
], c.prototype, "name", 2);
u([
  v({ type: String })
], c.prototype, "accept", 2);
u([
  v({ type: String })
], c.prototype, "label", 2);
u([
  v({ type: String })
], c.prototype, "description", 2);
u([
  Ae({ type: String, default: "" })
], c.prototype, "title", 2);
u([
  v({ type: Boolean })
], c.prototype, "multiple", 2);
u([
  v({ type: String })
], c.prototype, "text", 2);
u([
  q()
], c.prototype, "_files", 2);
u([
  q()
], c.prototype, "accepted", 2);
u([
  q()
], c.prototype, "dragOverDepth", 2);
c = u([
  Ee(ue)
], c);
export {
  c as PwcFileInput
};
